import { configureStore } from "@reduxjs/toolkit";
import RegistrationDataReducer from "./registration-dataSlice";

export const store = configureStore({
  reducer: {
    RegistrationData: RegistrationDataReducer,
  },
});
